import abbrv from 'number-abbreviate'

export const abbreviateNumber = (num: number | string | null | undefined, fixed?: number) => {
  if (num == null) {
    return '--'
  }
  return abbrv(num, fixed)
}

export function abbreviateNumberLong(num: number) {
  if (num >= 1000000 && num < 1000000000) {
    return (num / 1000).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + 'k'
  }

  if (num >= 1000000000 && num < 1000000000000) {
    return (num / 1000000).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + 'M'
  }

  if (num >= 1000000000000 && num < 1000000000000000) {
    return (num / 1000000000).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + 'B'
  }

  return abbrv(num, undefined)
}

export const prettyNumber = (num: number | string | null | undefined): string => {
  if (typeof num === 'number') {
    return num < 0.001 && num > -0.001 ? num.toString() : num.toLocaleString()
  }
  if (typeof num === 'string') {
    return num
  }
  return '--'
}

export function ordinalSuffix(i: number): string {
  if (i === 0) {
    return ''
  }

  const j = i % 10
  const k = i % 100
  if (j === 1 && k !== 11) {
    return 'st'
  }
  if (j === 2 && k !== 12) {
    return 'nd'
  }
  if (j === 3 && k !== 13) {
    return 'rd'
  }
  return 'th'
}

export type FormatValOption =
  | 'currency'
  | 'currency-expanded'
  | 'currency-long'
  | 'percentage'
  | 'percentage-change'
  | 'number'
  | 'short-number'
  | undefined
export const formatVal = (val: number | undefined | null, type: FormatValOption) => {
  if (!val) {
    return '--'
  }
  if (type === 'currency') {
    return `$${abbreviateNumber(val, 1)}`
  }
  if (type === 'currency-expanded') {
    const whole = Math.floor(val)
    const decimal = val - whole
    // format to -> $1,234.56
    return `$${val ? whole.toLocaleString() + decimal.toFixed(2).slice(1, 4) : `0.00`}`
  }
  if (type === 'short-number') {
    return `${abbreviateNumber(val, 1)}`
  }
  const formattedVal = prettyNumber(val)

  if (type === 'currency-long') {
    return `$${formattedVal}`
  }
  if (type === 'percentage') {
    return `${formattedVal}%`
  }
  if (type === 'percentage-change') {
    const sign = Math.sign(val) === -1 ? '' : '+'
    return `${sign}${formattedVal}%`
  }
  return formattedVal
}

export const getOrdinalNumberSuffix = (num: number) => {
  const j = num % 10
  const k = num % 100
  if (j == 1 && k != 11) {
    return 'st'
  }
  if (j == 2 && k != 12) {
    return 'nd'
  }
  if (j == 3 && k != 13) {
    return 'rd'
  }
  return 'th'
}
